/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Warm_Bold_Crane_SoarInputs */

const en_warm_bold_crane_soar = /** @type {(inputs: Warm_Bold_Crane_SoarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Available Languages`)
};

const de_warm_bold_crane_soar = /** @type {(inputs: Warm_Bold_Crane_SoarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verfügbare Sprachen`)
};

/**
* | output |
* | --- |
* | "Available Languages" |
*
* @param {Warm_Bold_Crane_SoarInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const warm_bold_crane_soar = /** @type {((inputs?: Warm_Bold_Crane_SoarInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Warm_Bold_Crane_SoarInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_warm_bold_crane_soar(inputs)
	return de_warm_bold_crane_soar(inputs)
});